import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import styled from 'styled-components';
import { respitePageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const Respite = () => {
  const defaultData = {
    title: "Respite Care",
    subtitle: "Short-term care when you need it",
    introText: "Our Residential respite care provides short-term care when you need it and if you intend to return to the community. Residential respite care may be used on a planned or emergency basis, to help if your carer is absent for any reason such as illness or holidays.",
    costHeader: "Costs",
    costText: "Charges are regulated by the Federal Government refer our Fees & Charges page for more information.",
    applicationHeader: "Application",
    applicationText: "To apply for respite contact the regional Care2Serve on 6144 3722."
  };

  const customContent = (pageData) => (
    <>
      <Section>
        <SectionTitle>
          {pageData.costHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.costText}
        </Paragraph>
      </Section>
      
      <Section>
        <SectionTitle>
          {pageData.applicationHeader}
        </SectionTitle>
        <Paragraph>
          {pageData.applicationText}
        </Paragraph>
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="respitePage"
      query={respitePageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default Respite;
